import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWetransferComponent } from './simple-icons-wetransfer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWetransferComponent ],
    exports:      [ SimpleIconsWetransferComponent ],
    bootstrap:    []
})
export class SimpleIconsWetransferModule {}
